module.exports = __webpack_public_path__ + "img/icon-shutters.04ea625f.svg";